import { createBrowserRouter, RouterProvider, Navigate } from "react-router";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Conversations from "@/pages/Conversations";
import Templates from "@/pages/Templates";
import BulkSend from "@/pages/BulkSend";
import OptOuts from "@/pages/OptOuts";
import Devices from "@/pages/Devices";
import Staff from "@/pages/Staff";
import BookingPage from "@/pages/BookingPage";
import SettingsPage from "@/pages/Settings";
import Help from "@/pages/Help";

const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/booking", element: <BookingPage /> },
  { path: "/b/:code", element: <BookingPage /> },
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: "messages", element: <Messages /> },
      { path: "conversations", element: <Conversations /> },
      { path: "templates", element: <Templates /> },
      { path: "bulk-send", element: <BulkSend /> },
      { path: "opt-outs", element: <OptOuts /> },
      { path: "devices", element: <Devices /> },
      { path: "staff", element: <Staff /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "help", element: <Help /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
